import * as Types from '../constants/Types';

export const getListTagGroupDetails = (params) => ({ type: Types.TAG_GROUP_DETAIL_LIST_ACTION, params });
export const setListTagGroupDetails = (data) => ({ type: Types.TAG_GROUP_DETAIL_LIST_SUCCESS, ...(data || {}) });

export const getTagGroupDetailItem = (id) => ({ type: Types.TAG_GROUP_DETAIL_GET_UPDATE_ACTION, id });
export const setTagGroupDetailItem = (tagGroupDetail) => ({ type: Types.TAG_GROUP_DETAIL_GET_UPDATE_SUCCESS, tagGroupDetail });
export const updateTagGroupDetail = (tagGroupDetail, callbacks) => ({ type: Types.TAG_GROUP_DETAIL_UPDATE_ACTION, tagGroupDetail, callbacks });
export const createTagGroupDetail = (tagGroupDetail) => ({ type: Types.TAG_GROUP_DETAIL_CREATE_ACTION, tagGroupDetail });
export const deleteTagGroupDetail = (tagGroupDetail, refreshParams) => ({ type: Types.TAG_GROUP_DETAIL_DELETE_ACTION, tagGroupDetail, refreshParams });

export const getAllTagGroupDetail = () => ({ type: Types.TAG_GROUP_DETAIL_GET_ALL_ACTION });
export const setAllTagGroupDetail = (tagGroupDetails) => ({ type: Types.TAG_GROUP_DETAIL_GET_ALL_SUCCESS, tagGroupDetails });

export const getAllTagGroup = () => ({ type: Types.TAG_GROUP_GET_ALL_ACTION });
export const setAllTagGroup = (tagGroups) => ({ type: Types.TAG_GROUP_GET_ALL_SUCCESS, tagGroups });

export const getAllSku = (typeKey) => ({ type: Types.TAG_GROUP_GET_ALL_SKU_ACTION, typeKey });
export const setAllSku = (skus, typeKey) => ({ type: Types.TAG_GROUP_GET_ALL_SKU_SUCCESS, skus, typeKey });

export const mapSkuAction = (params) => ({ type: Types.TAG_GROUP_DETAIL_MAP_SKU_ACTION, params });
export const mapSkuSuccess = () => ({ type: Types.TAG_GROUP_GET_ALL_SKU_SUCCESS });

export const createTagGroupDetailTranslate = (tagGroupDetail) => ({ type: Types.TAG_GROUP_DETAIL_CREATE_TRANSLATE_ACTION, tagGroupDetail });
export const updateTagGroupDetailTranslate = (tagGroupDetail) => ({ type: Types.TAG_GROUP_DETAIL_UPDATE_TRANSLATE_ACTION, tagGroupDetail });
export const deleteTagGroupDetailTranslate = (tagGroupDetail, refreshParams) => ({ type: Types.TAG_GROUP_DETAIL_DELETE_TRANSLATE_ACTION, tagGroupDetail, refreshParams });

export const getTagInTagroup = (params) => ({ type: Types.GET_TAG_IN_TAGGROUP_ACTION, params });
export const setTagIntagGroup = (data) => ({ type: Types.GET_TAG_IN_TAGGROUP_SUCCESS, ...(data || {}) });

export const getTagBySku = (id) => ({ type: Types.GET_TAG_BY_SKU_ACTION, id });
export const setTagBySku = (data) => ({ type: Types.GET_TAG_BY_SKU_SUCCESS, ...(data || {}) });

export const updateTagGroupSKUMapping = (skuTags) => ({ type: Types.TAG_GROUP_SKU_MAPPING_UPDATE_ACTION, skuTags });

export const getTagsByGroup = (params) => ({ type: Types.TAG_GROUP_GET_BY_TAG_GROUP_ACTION, params });
export const setTagsByGroup = (tagGroups) => ({ type: Types.TAG_GROUP_GET_BY_TAG_GROUP_SUCCESS, tagGroups });
